import { render, staticRenderFns } from "./Widget9.vue?vue&type=template&id=0e4c463c&scoped=true"
import script from "./Widget9.vue?vue&type=script&lang=js"
export * from "./Widget9.vue?vue&type=script&lang=js"
import style0 from "./Widget9.vue?vue&type=style&index=0&id=0e4c463c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4c463c",
  null
  
)

export default component.exports